const o=".gator-checkbox-group,.gator-checkbox-group-container{display:flex;flex-direction:column;gap:var(--spacing-gap-8)}";export{o as default};
